import styled from 'styled-components'
import { Menu } from 'antd'
import {
  SharedNotificationAvatar,
  SharedNotificationContent,
  SharedNotificationDate,
  SharedNotificationLeft,
  SharedNotificationRight,
  SharedNotificationRow,
  SharedNotificationTitle,
} from '../../components/NotificationShared/NotificationItemStyled'

export const NotificationPageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 8px 0 24px 0;

  .notification-tabs {
    .ant-tabs-nav {
      margin-bottom: 12px;

      &::before {
        border-bottom: 1px solid #f0f0f0;
      }
    }

    .ant-tabs-tab {
      padding: 8px 16px;
      font-size: 14px;
      color: #64748b;
      transition: color 0.2s;

      &.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #1890ff;
        font-weight: 600;
      }
    }

    .ant-tabs-ink-bar {
      background: #1890ff;
      height: 2px;
    }
  }
`

export const NotificationHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  .page-title {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #0f172a;
    line-height: 32px;
  }

  .mark-all-btn {
    border-radius: 6px;
    height: 36px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-color: #d9d9d9;
    color: #334155;

    &:hover {
      color: #1890ff;
      border-color: #1890ff;
    }
  }
`

export const NotificationListCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 4px 0;
  min-height: 400px;

  .center-spin {
    padding: 24px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const NotificationRowItem = styled(SharedNotificationRow).attrs({
  $variant: 'full',
})``

export const NotificationRowLeft = styled(SharedNotificationLeft).attrs({
  $variant: 'full',
})``

export const NotificationAvatar = styled(SharedNotificationAvatar).attrs({
  $variant: 'full',
})``

export const NotificationTextGroup = styled(SharedNotificationContent).attrs({
  $variant: 'full',
})``

export const NotificationTitle = styled(SharedNotificationTitle).attrs({
  $variant: 'full',
})``

export const NotificationDate = styled(SharedNotificationDate).attrs({
  $variant: 'full',
})``

export const NotificationRowRight = styled(SharedNotificationRight).attrs({
  $variant: 'full',
})``

export const MoreActionTrigger = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #e2e8f0;
    color: #475569;
  }
`

export const StyledNotificationMenu = styled(Menu)`
  &.ant-dropdown-menu {
    background: #ffffff;
    border-radius: 12px;
    padding: 6px;
    min-width: 120px;
    border: none;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08), 0 2px 6px rgba(0, 0, 0, 0.04);

    .ant-dropdown-menu-item-selected {
      background-color: transparent;
    }

    .ant-dropdown-menu-item {
      display: flex !important;
      align-items: center !important;
      padding: 7px 12px !important;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 400;
      color: #0f172a;
      transition: all 0.2s ease;
      cursor: pointer;
      margin: 1px 0;
      line-height: 20px;

      .ant-dropdown-menu-item-icon {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        font-size: 16px;
        margin-right: 10px !important;
        color: #016db2;
        transition: color 0.2s ease;
        min-width: 16px;
      }

      .ant-dropdown-menu-title-content {
        color: #0f172a;
        transition: color 0.2s ease;
      }

      &.menu-item-read {
        &:hover,
        &.ant-dropdown-menu-item-active {
          background-color: #f1f5f9;

          .ant-dropdown-menu-title-content {
            color: #0f172a;
          }
        }
      }

      &.menu-item-delete {
        &:hover,
        &.ant-dropdown-menu-item-active {
          background-color: #fff1f0;

          .ant-dropdown-menu-item-icon {
            color: #ff4d4f;
          }

          .ant-dropdown-menu-title-content {
            color: #ff4d4f;
          }
        }
      }
    }
  }
`
